"use client";

import { cn } from "@istari-frontend/shared";
import { Tabs as TabsPrimitive } from "radix-ui";
import * as React from "react";
import { JSX, useContext } from "react";

import { raisedItemVariants, type RaisedSize, raisedTrackVariants } from "./raised-variants";

export const tabsListVariants = raisedTrackVariants;

export const tabsTriggerVariants = raisedItemVariants;

const TabsSizeContext = React.createContext<RaisedSize>("default");

export function Tabs<TTab extends string>(
  props: Omit<React.ComponentProps<typeof TabsPrimitive.Root>, "value" | "defaultValue" | "onValueChange"> & {
    value?: TTab;
    defaultValue?: TTab;
    onValueChange?: (value: TTab) => void;
  },
): JSX.Element;
export function Tabs({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root data-slot="tabs" className={cn("flex flex-col gap-2", className)} {...props} />;
}

export function TabsList({
  className,
  size,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List> & { size?: RaisedSize }) {
  return (
    <TabsSizeContext.Provider value={size}>
      <TabsPrimitive.List data-slot="tabs-list" className={cn(tabsListVariants({ size }), className)} {...props} />
    </TabsSizeContext.Provider>
  );
}

export function TabsTrigger({
  className,
  size,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger> & { size?: RaisedSize }) {
  const contextSize = useContext(TabsSizeContext);
  const resolvedSize = size ?? contextSize;

  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(tabsTriggerVariants({ size: resolvedSize }), className)}
      {...props}
    />
  );
}

export function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return <TabsPrimitive.Content data-slot="tabs-content" className={cn("flex-1 outline-none", className)} {...props} />;
}
